export const APP_AUTH_KEY = "@GiftHoichoi"
export const enableRoleBasedRoutes = false

const DEV_KEYS = {
    REACT_APP_IPGEOLOCATION_KEY: 'c1d94f000a05421d8ca02acdbf2c967e',
    REACT_APP_RAZORPAY_KEY: 'rzp_test_YaUKom9QVI26vG',
    REACT_APP_WHATSAPP_HELPLINE: '8017990000',
    REACT_APP_SENTRY_DSN: "https://aecd24e3818e43d29ea4e3d02081bad3@o556393.ingest.sentry.io/5687212",
    REACT_APP_IP_INFO_KEY: '391146f2de14bf',
    REACT_APP_STRIPE_TOKEN: 'pk_test_51J0IjySHJmt5pVZYqaJN98os1gwVrKZkj50j6gjV4JCLOQrZfIT3x48YgaTe9C81UUJpJAplRRsVNkHYLxzaPwaW00LP430qvy',
    REACT_APP_GOOGLE_GEOLOCATION_KEY: 'AIzaSyBE1cvAtzFJeWrIHHaFWIv_bmcMHsk6JsU',
    REACT_APP_OPENCAGEDATA_KEY: 'a37609e02aa14ac1aa2a7a4beacbf847',
    REACT_APP_SUPERBASE_APIKEY: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZycndheHFlaWVobWp6bWJnZ3JxIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NDUxODQ2ODksImV4cCI6MTk2MDc2MDY4OX0.U-kwrF_EDPPORgtojcdmP-N1WMhV8jATddOmue8zAC4',
    REACT_APP_SUPERBASE_BASEURL: 'https://vrrwaxqeiehmjzmbggrq.supabase.co',
    REACT_APP_BACKEND_URL: 'https://admin.hoichoioffers.com/api',
}

const PROD_KEYS = {
    REACT_APP_IPGEOLOCATION_KEY: 'c1d94f000a05421d8ca02acdbf2c967e',
    REACT_APP_RAZORPAY_KEY: 'rzp_live_imdYUgCua5z9JR',
    REACT_APP_WHATSAPP_HELPLINE: '8017990000',
    REACT_APP_SENTRY_DSN: "https://aecd24e3818e43d29ea4e3d02081bad3@o556393.ingest.sentry.io/5687212",
    REACT_APP_IP_INFO_KEY: '391146f2de14bf',
    REACT_APP_STRIPE_TOKEN: 'pk_live_51J0IjySHJmt5pVZYOSeEXZ65nXfe58XwqZiCvjR3MKByAeZZnEa97cZLVCRfayKKDm7pkBfGrLtrXopIFzSvUkoW00fsDhaLu1',
    REACT_APP_GOOGLE_GEOLOCATION_KEY: 'AIzaSyBE1cvAtzFJeWrIHHaFWIv_bmcMHsk6JsU',
    REACT_APP_OPENCAGEDATA_KEY: 'a37609e02aa14ac1aa2a7a4beacbf847',
    REACT_APP_SUPERBASE_APIKEY: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZycndheHFlaWVobWp6bWJnZ3JxIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NDUxODQ2ODksImV4cCI6MTk2MDc2MDY4OX0.U-kwrF_EDPPORgtojcdmP-N1WMhV8jATddOmue8zAC4',
    REACT_APP_SUPERBASE_BASEURL: 'https://vrrwaxqeiehmjzmbggrq.supabase.co',
    REACT_APP_BACKEND_URL: 'https://admin.hoichoioffers.com/api',
}




// env variables
export const localEnvVariables = PROD_KEYS